// Hook odpowiedzialny za dry-run importu CSV do koszyka (preview)

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

// parametry requestu do api
interface IRequest {
  file: string;
}

// pojedyncza pozycja valid w preview
export interface ICartImportPreviewValidRow {
  row_number: number;
  product_id: number;
  product_key: string;
  product_key_type: string;
  product_name: string | Array<{ language: string; translation: string }> | null;
  product_symbol: string | null;
  product_id_external: string | null;
  unit: string | null;
  quantity: number;
  already_in_cart: boolean;
  current_quantity: number;
  resulting_quantity: number;
}

// pojedynczy invalid wiersz
export interface ICartImportPreviewInvalidRow {
  row_number: number;
  reason: string;
  raw_value: string;
  product_key?: string | null;
  product_name?: string | null;
  available_units?: string[];
}

// summary
export interface ICartImportPreviewSummary {
  total: number;
  valid_count: number;
  invalid_count: number;
  will_add: number;
  will_merge: number;
}

// typ zwracanych danych
interface IResponse extends ICommandResponseSuccess {
  data: {
    valid: ICartImportPreviewValidRow[];
    invalid: ICartImportPreviewInvalidRow[];
    summary: ICartImportPreviewSummary;
  };
}

const postCartImportPreview = (cartId: number, data: IRequest): Promise<IResponse> =>
  axios.post(`/carts/${cartId}/import/preview`, data);

export const usePostCartImportPreview = (
  cartId: number,
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => postCartImportPreview(cartId, data), options);
